export default "__VITE_ASSET__90f86f42__"